import { auth } from './utils/auth';
import { initializeGloballyExposedAuthHelpers } from './auth/auth-utils';
import { onAuthChange } from './redux/slice/authSlice';
import { PropsWithChildren, useEffect } from 'react';
import { useAppDispatch } from './redux/store';
import { useAuth0 } from '@equipmentshare/auth0-react';

function InitAuth({ children }: PropsWithChildren) {
  const auth0 = useAuth0();
  const dispatch = useAppDispatch();

  useEffect(() => {
    auth.setAuth0(auth0);
    dispatch(onAuthChange());
  }, [auth0]);

  useEffect(() => {
    initializeGloballyExposedAuthHelpers();
  }, []);

  return <>{children}</>;
}

export default InitAuth;
